module.exports = __webpack_public_path__ + "static/media/whichThinnerQuestion.45373303.mp3";